<template>
	<custom-popover ref="methodsPopover" class="template-methods-popover" :backdrop="true" >
        <img @click.stop.prevent="onClose()" class="close-popover" src="@/assets/svg/close.svg">
            <div class="popover-header">
                <span>{{$t('methods.title')}}</span>
                <button class="btn btn-primary create-btn" @click="createMethodClicked = createMethodClicked = true, selectedMethod = null">New method</button>
            </div>
        <div class="extra-variables-wrapper">
            <div class="left custom-scrollbar-light"> 
                <div class="extra-variables-list "  v-if="!showVars" >
                    <div v-if="templateMethods.length == 0" class="no-methods">
                        <span style="margin: 0 auto;">{{$t('methods.no-methods')}}</span>
                    </div>
                    <div 
                        v-else
                        class="extra-variable"
                        v-for="(templateMethod, index ) in templateMethods" 
                        :key="index"
                        @click="selectedMethod = templateMethods[index], createMethodClicked = false"
                        :class="{'is-selected':  templateMethod == selectedMethod}"
                        >
                        <div class="flex-grow-1">
                            <div>{{templateMethod.name}}</div>
                            <!-- <div class="text-muted">some info here?</div> -->
                        </div>
                        <img src="@/assets/svg/chevronRight.svg" />
                    </div>
                </div>
                <div class="backdrop-vars" v-if="showVars" @click.self.prevent.stop="handleBackdrop"></div>
                <div class="popover-step" v-if="showVars"  >
                    <div v-if="variableGroups && !loading" :class="{'slide-out-vars' : showVarsAnim}">
                        <variable-selector
                            class="variable-list"
                            :variable-groups="variableGroups"
                            :show-values=true
                            :selectedVariableName="selectedTemplateVariable"
                            @variable-name-changed="handleVariableSelect"
                        />
                    </div>	
                    <div v-if="loading" style="margin-top: 30px" class="text-center text-muted">
                        <i class="fa-light fa-circle-notch fa-spin"></i>
                    </div>
                    <div class="actions" v-if="!showVarsAnim">
                        <div class="cancel" @click="showVars = !showVars">{{$t("extra-variables.cancel")}}</div>
                        <div class="add-to-expression" :disabled="!selectedTemplateVariable" @click="addToExpression">{{$t("extra-variables.add")}}</div>
                    </div>
                </div>
            </div>
            <div class="right custom-scrollbar-light">
                

                <create-template-method v-if="createMethodClicked" @get-variable-groups="getVars" :templateMethods="templateMethods" @create-and-close="createMethodClicked = false, updatePreview(), selectedVariable = templateMethods[templateMethods.length - 1] "/>
                <edit-template-method v-if="selectedMethod" @detect-changes="hasChanges = true" @get-variable-groups="getVars" :selectedMethod="selectedMethod" @delete-var="deleteExtraVariable" @update-var="updateExtraVariable" :varType="selectedMethod.expression ? selectedMethod.mappings && Object.keys(selectedMethod.mappings).length != 0? 'Dictionary' : 'Standard' : 'If'"/>


                <div v-if="selectedMethod"  class="save-footer" :class="{ 'can-save': hasChanges }">
					<div class="cancel" @click="deleteExtraVariable">{{$t("extra-variables.delete")}} 
						<img src="@/assets/svg/trash-button-no-circle.svg" />
					</div>
					<div class="save" @click="handleSave">{{$t("extra-variables.save")}}
						<icon-base style="margin-left: 4px;" iconColor="none" width="14" height="14" icon-name="save"><icon-save /></icon-base>
					</div>
				</div>

                <button v-if="!createMethodClicked && !selectedMethod" class="no-methods btn btn-primary" @click="createMethodClicked = createMethodClicked = true, selectedMethod = null">{{$t("extra-variables.create-btn")}}</button>

            </div>
        </div>
	</custom-popover>
</template>

<script>
import CustomPopover from '@/components/CustomPopover';
import VariableSelector from '@/components/VariableSelector'
import CreateTemplateMethod from '@/components/CreateTemplateMethod'
import EditTemplateMethod from '@/components/EditTemplateMethod'
import EventBus from "@/assets/js/eventBus.js";
import IconBase from '@/components/icons/IconBase'
import IconSave from '@/components/icons/IconSave'
import ConfirmModal from "@/components/modals/ConfirmModal";
export default {
  name: "templateMethodsPopover",
  data() {
    return {
        selectedType: "",
        createMethodClicked: false,
        selectedMethod: null,
        popoverStyle: {},
        variables: null,
        loading: null,
        showVars: false,
        selectedTemplateVariable: null,
        showVarsAnim: false,
        hasChanges: false
        // invalid: false
    }
  },
 methods:{
     handleSave(){
        EventBus.$emit('save-extra-variable')
        this.hasChanges = false
    },
    editVariable(index){
        this.selectedMethod = this.templateMethods[index]
    },
    updateExtraVariable(copy){
        let updaterVar = this.templateMethods.findIndex((v => v.name == copy.name));
        //    this.templateMethods[updaterVar] = copy;
        this.selectedMethod = copy
        this.$set(this.templateMethods, updaterVar, copy)
        this.$store.state.unsavedChanges = true
        this.updatePreview()
    },
     onClose () {
        this.$emit('close')   
    },
    getVars (result) {
        this.showVars = true
        this.variables = null
        // this.selectedDatasetId = result ? result.id : null
        this.loading = true
        this.$store.dispatch('getVariables', { template: this.$store.state.template.metadata, id: result ? result.id : null }).then(vars => {
            this.variables = vars
            this.loading = false
        }, () => { this.loading = false })
    },
    handleVariableSelect(selectedTemplatevar){
        this.selectedTemplateVariable = selectedTemplatevar
    },
    addToExpression(){
        EventBus.$emit("add-to-expression", this.selectedTemplateVariable);
        this.showVars = false

        // this.templateMethod.expression = this.templateMethod.expression + this.selectedTemplateVariable
    },

    deleteExtraVariable(){
        this.$modal.show(
        ConfirmModal,
        {
          title: this.$t("extra-variables.delete-title"),
          description: this.$t("extra-variables.delete-desc") + ` ${this.selectedMethod.name.includes('_') ?  this.selectedMethod.name.substring(this.selectedMethod.name.lastIndexOf('_') + 1, this.selectedMethod.name.length-1 ) : this.selectedMethod.name.substring(1, this.selectedMethod.name.length-1)}?`,
          confirmButtonText: this.$t("extra-variables.delete-btn"),
          onConfirm: (result) => {
            this.templateMethods.splice(this.templateMethods.findIndex((v) => v.name == this.selectedMethod.name) ,1);
            this.selectedMethod = null
            this.$store.state.unsavedChanges = true
            this.updatePreview()
            this.selectedMethod = this.templateMethods[this.templateMethods.length - 1]
          },
        },
        { width: 310, height: "auto", adaptive: true },
      );
       
    },
    updatePreview(){
        // console.log(this.$route.params.templateId)
        this.$store.dispatch('getTemplatePreview', {
                template: this.$store.state.template,
                variables: this.$store.state.templateVariables
            }).then(preview => {
                // this.$store.state.templatePreview = preview
                this.$store.commit("setTemplatePreview", preview);
        })
    },
    handleBackdrop(){
        this.showVarsAnim = true
        setTimeout(() => {
            this.showVars = false
            this.showVarsAnim = false
        }, 160);
    }
},
computed:{
    templateMethods () {
        return this.$store.state.template.methods
    },
      variableGroups () {
        return this.$store.getters.variableGroups
    }
},
mounted(){
    if(this.templateMethods){
        this.selectedMethod = this.templateMethods[0] 
    }
},
    watch:{
         selectedMethod: {
            handler: function (val, oldVal) {
               this.hasChanges = false
            }
        }
    },
    beforeDestroy(){
        this.$store.dispatch('updateTemplateMethods', this.templateMethods)
    },
  components:{
      CustomPopover,
      VariableSelector,
      CreateTemplateMethod,
      EditTemplateMethod,
      IconBase,
      IconSave
  },

}
</script>

<style lang="less">
       .template-methods-popover{
        width: 840px;
        // height: 500px;
		line-height: 1.5;
		background-color: #fff;
		position: absolute;
        color: #3d464a;
		&.custom-popover {
			background-color: #fff;
			right: calc(50% - (840px / 2));
			left: unset;
			top: calc(50% - (500px / 2));
			&::before {
				// content: url(*/svg/close.svg);
				display: none;
			}

			.close-button {
				display: none;
            }
            
        }

            .extra-variable {
				display: flex;
				padding: 5px 20px;
				cursor: pointer;
				span {
					flex-grow: 1;
				}
				img {
					display: none;
				}
				&:hover {
					background-color: rgba(219, 218, 218, .4);
					> img {
						display: block;
					}
				}

				&.is-selected {
					background-color: rgba(219, 218, 218);
					img {
						display: inline-block;
					}
                }
   }

        .extra-variables-wrapper{
            display: grid;
            grid-template-columns: 1fr 1fr;
            background-color: #fff;
            height: 420px;
         


            .right{
                // background-color: #3d464a41;
                background-color: #fff;
                overflow: auto;
                 -webkit-box-shadow: inset 2px 0px 3px -1px  rgba(0, 0, 0, 0.25); 
                box-shadow: inset 2px 0px 3px -1px rgba(0,0,0,0.25);
            }
            .left{
            overflow: auto;
            
            .popover-step{
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    width: auto;

                    .variable-selector.variable-list{
                    animation: slideInVars .2s ease;
                    z-index: 103;
                    width: auto;
                    // height: auto;
                    
                    
                    }
                    .variable-list-wrapper {
                        z-index: 103;
                        // max-height: none; // Get dynamic height for popup
                        max-height: 325px;
                    }

                    .actions{
                        position: absolute;
                        height: 36px;
                        bottom: 0;
                        width: 50%;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        border-top: 1px solid #3d464a5d;
                        // border: 1px solid black;
                        z-index: 103;
                        div{
                            border-left: 1px solid #3d464a5d;
                            cursor: pointer;
                            // margin: 0 auto;
                            text-align: center;
                            width: 100%;
                            padding: 7px;
                        }
                    }
                }
            }
        }
           
    img.close-popover{
	position: absolute;
    top: -9px;
    right: -8px;
	z-index: 101;
	cursor: pointer;
        }
        
        .form-group{
            margin-bottom: 0;

            .form-control{
                    // padding: 0px 8px 10px 0;
                      &:invalid {
                         color: #8F979C;;
                        }
            }
        }

        .hide{
            opacity: 0;
            pointer-events: none;
            }


             select option:disabled{
                    color: red;
                }


                .no-methods{
                    margin: 100px auto;
                    text-align: center;
                    font-size: 18px;
                    display: flex;
                    
                }


        .create-btn::after{
            content: "+";
            border: 1px solid white;
            border-radius: 100%;
            width: 20px;
            height: 20px;
            padding: 0 4px;
            margin: 0 0 0 10px;
        }


    .backdrop-vars {
        position: fixed;
        z-index: 102;
        height: 100%;
        width: 100%;
        left: 0;
        top: 0;
        //   background-color: rgba(0, 0, 0, 0.25);
    }


          .slide-out-vars{
            //   animation-direction: reverse;
                     animation: slideInVars .2s ease reverse !important;
                    }

                            @keyframes slideInVars {
                        from{
                            transform: translateX(300px);
                            opacity: 0;
                        }
                        to{
                            transform: translateX(0px);
                            opacity: 1;
                        }      
                    }


        .save-footer {
            -webkit-box-shadow: inset 2px 0px 3px -1px  rgba(0, 0, 0, 0.25); 
            box-shadow: inset 2px 0px 3px -1px rgba(0,0,0,0.25);
			display: flex;
            position: absolute;
            z-index: 1;
            background-color: #fff;
            bottom: 0;
            // height: 35px;
            width: 50%;
			text-align: center;
			border-top: 1px solid #3d464a5d;
			.save, .cancel {				
				flex: 1 1 auto;
				line-height: 35px;
                    cursor: pointer;
				&:hover {
					// color: #000;
				}
			}
			.save {
				color: #3d464a70;
                border-left: 1px solid #3d464a5d;
                pointer-events: none;
			}
			&.can-save {
                .save {
                    pointer-events: auto;
					color: #3d464a;

					&:hover {
						color: #000;
					}
				}
			}
				svg{
				margin-left: 4px;
				height: 15px;
				width: auto;
			}
		}
}

</style>


